// Full-document render of the sealy ProductLinePage: PageSkeleton (the React
// document shell) wrapping the legacy product_line_page.html content block --
// the product hero (hero assembly + modular configurator; unlike the PDP, no
// special-offer assembly) and the consolidated PLP body -- with the same
// container/section DOM the sealy SCSS anchors to (#product-detail-container,
// .alternative-design, .product-hero, .product-hero__blocks,
// .product-hero__configurator, .pdp-blocks).
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ProductLinePageBody } from "../components/ProductLinePageBody";
import { Template as ModularConfigurator } from "./ModularConfiguratorTemplate";
import { Template as ProductHeroAssembly } from "./ProductHeroAssemblyTemplate";

// Mutable reactivated props (not Immutable<>): PageSkeleton composes the
// in-tree SiteHeader chain, which is typed with mutable reactivated props.
// The hero/body templates accept Immutable props, to which these are
// assignable.
export const Template = (
    props: templates.ProductLinePageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <div
            id="product-detail-container"
            className={
                props.use_default_design ? undefined : "alternative-design"
            }
        >
            <section className="product-hero">
                <div className="product-hero__blocks">
                    <ProductHeroAssembly {...props.hero} />
                </div>
                {/* The legacy class list appended
                    `{{ page.configurator_background_style }}`, a cocoon-only
                    field no sealy PDP model defines -- it always rendered
                    empty. */}
                <div className="product-hero__configurator">
                    <ModularConfigurator {...props.configurator} />
                </div>
            </section>
            <div className="pdp-blocks">
                <ProductLinePageBody
                    page={props.page}
                    reviews={props.reviews}
                    page_num_reviews={props.page_num_reviews}
                    change_variant_ssr={props.change_variant_ssr}
                    change_root_ssr={props.change_root_ssr}
                    root_conditional_ssr={props.root_conditional_ssr}
                    variant_conditional_ssr={props.variant_conditional_ssr}
                    tab_cards_initial_root_product_id={
                        props.tab_cards_initial_root_product_id
                    }
                />
            </div>
        </div>
    </PageSkeleton>
);
